import { getInstance } from './index'

function allowedRoute (route, auth) {
  if ('roles' in auth && auth.roles.includes('superadmin')) {
    return true
  }
  const appTenant = route.params.customer
  if ('groups' in auth && auth.groups.includes(appTenant)) {
    return true
  }
  return false
}

function getDefaultTenant (auth) {
  if (auth.groups.length === 0) {
    return null
  }
  return auth.groups[0]
}

export const authGuard = (to, from, next) => {
  const authService = getInstance()

  const getTargetUrl = () => {
    const targetUrl = localStorage.getItem('targetUrl')
    return targetUrl && targetUrl !== 'undefined' ? targetUrl : to.fullPath
  }

  const fn = () => {
    // If the user is authenticated, continue with the route
    if (authService.isAuthenticated) {
      // auth0 root request pass-through
      if (!to.params.customer && to.query.code && to.query.state) {
        return next()
      }

      const userAuth = authService.user['https://starlightintel.com/roles']
      if (!to.params.customer && !(to.query.code && to.query.state)) {
        return next({ path: '/' + getDefaultTenant(userAuth) })
      }
      if (localStorage.getItem('targetUrl') || allowedRoute(to, userAuth)) {
        localStorage.removeItem('targetUrl')
        return next()
      // } else if (!userAuth.groups.includes(to.params.customer)) {
      //   return next({ path: '/404' })
      } else {
        return next({ path: '/authorization-failed', query: { targetUrl: getTargetUrl() } })
      }
    }

    // Otherwise, log in
    authService.loginWithRedirect({ appState: { targetUrl: getTargetUrl() } })
  }

  // If loading has already finished, check our auth state using `fn()`
  if (!authService.loading) {
    return fn()
  }

  // Watch for the loading property to change before we check isAuthenticated
  authService.$watch('loading', loading => {
    if (loading === false) {
      return fn()
    }
  })
}
